import { BottomBarSelect } from '../../components/BottomBarSelect';
import { ColorPickerField } from '../../components/ColorPickerField';
import { IconField } from '../../components/IconField';
import FeedbackBlock from './FeedbackBlock';

// use a type here, not an interface
// type Data = {
//   style: {
//     title: string,
//     padding: number;
//     icon: string;
//     iconBackground: string;
//     titlePosition: string;
//     titleType: string;
//     iconColor: string;
//     bgColor: string;
//     textColor: string;
//     blockPosition: string;
//     documentLink: string;
//   };
// }

const feedBackBlockController: any = {
  Renderer: ({ data }: any) => (
    <FeedbackBlock
      title={data?.style?.title}
      icon={data?.style?.icon}
      iconBackground={data?.style?.iconBackground}
      iconColor={data?.style?.iconColor}
      bgColor={data?.style?.bgColor}
      textColor={data?.style?.textColor}
      // titlePosition={data?.style?.titlePosition as any}
      // titleType={data?.style?.titleType}
      padding={data?.style?.padding}
      blockPosition={data?.style?.blockPosition}
      documentLink={data?.style?.documentLink}
    />
  ),
  id: 'feedbackBlockController',
  title: 'Page Title 2',
  description: 'A block for the feedback page',
  version: 1,
  controls: [
    {
      title: 'Configuration',
      controls: {
        type: 'autoform',
        schema: {
          type: 'object',
          required: [],
          properties: {
            style: {
              type: 'object',
              required: [],
              properties: {
                title: {
                  type: 'string',
                  default: 'Title',
                },
                icon: {
                  type: 'string',
                  default: 'Anchor 2',
                  uniforms: {
                    component: IconField,
                    label: 'Icon: ',
                  },
                },
                iconBackground: {
                  type: 'string',
                  default: 'rgba(70, 56, 125,1)',
                  uniforms: {
                    component: ColorPickerField,
                    label: 'Icon Background Color: ',
                  },
                },
                iconColor: {
                  type: 'string',
                  default: 'rgba(255,255,255,1)',
                  uniforms: {
                    component: ColorPickerField,
                    label: 'Icon color: (*where applicable) ',
                  },
                },
                textColor: {
                  type: 'string',
                  default: 'rgba(70, 56, 125,1)',
                  uniforms: {
                    component: ColorPickerField,
                    label: 'Text Color: ',
                  },
                },
                blockPosition: {
                  type: 'string',
                  uniforms: {
                    component: BottomBarSelect,
                    label: 'Block Position:',
                    value: 'flex-start',
                    options: [
                      { key: 'Left', value: 'flex-start', label: 'Left' },
                      { key: 'Center', value: 'center', label: 'Center' },
                      { key: 'Right', value: 'flex-end', label: 'Right' },
                    ],
                  },
                },
                documentLink: {
                  type: 'string',
                  default: '',
                },
              },
            },
          },
        },
      },
    },
  ],
};

export default feedBackBlockController;
